// Delegate — the headless hook moved to `@heidi/workspace/data` (D2,
// ARCFE-1062). This file owns the app reactions (ARCFE-921): the destructive
// toast and the COMPOSITE `invalidateCurrentUser()` (GET_USER *and* the commerce
// GET_PRODUCTS behind one try/catch).
import { toast } from '@heidi/design-system/toast';
import { useMutateUpdateUserOnboardingTask as useMutateUpdateUserOnboardingTaskCore } from '@heidi/workspace/data';
import { invalidateCurrentUser } from '../query/useQueryUser';

export function useMutateUpdateUserOnboardingTask() {
  return useMutateUpdateUserOnboardingTaskCore({
    onOnboardingTaskUpdated: () => {
      void invalidateCurrentUser();
    },
    onOnboardingTaskError: (error) => {
      toast({
        tone: 'destructive',
        title: 'Failed to update user onboarding task',
        description: error.message,
      });
    },
  });
}
